export enum PropertyActionType {
  Inc = 'Increment',
  Dec = 'Decrement',
  Set = 'Set',
}

export enum SetPropertyActionValue {
  Property = 'Property',
  Calculate = 'Calculate',
  Constant = 'Constant',
  Now = 'Now'
}
